<template>
  <v-form ref="temasForm">
  <v-select
    id="temas-select"
    v-model ="filter.temaId"
    item-text ="nome"
    item-name ="nome"
    item-value ="temaId"
    :items="temasFiltrados"
    :rules="[value => !!value || 'Campo Obrigatório']"
    label ="Temas *"
    placeholder ="Temas"
    v-on:change ="$emit('onChange')"
    :disabled = "disabled"
  >
    <template slot="no-data">
      Nenhum Tema
    </template>
  </v-select>
  </v-form>
</template>

<script>
import { perguntaAPI } from '../API/Pergunta'
import { mapActions } from 'vuex'

export default {
  name: 'AppTemasCombobox',
  props: {
    filter: { type: Object },
    disabled: { type: Boolean, default: false }
  },
  async mounted () {
    await this.loadTemas()
    await this.loadEixos()
    this.setTemasWithEixo(this.filter)
  },
  watch: {
    filter: {
      handler (val, oldVal) {
        this.setTemasWithEixo(val)
      },
      deep: true
    }

  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    rules () {
    },

    validate () {
      return this.$refs.temasForm.validate()
    },
    loadTemas () {
      return perguntaAPI.getTemas()
        .then(resp => {
          this.temas = resp.data
        })
        .catch()
    },
    loadEixos () {
      return perguntaAPI.getEixos()
        .then(resp => {
          this.eixos = resp.data
        })
        .catch()
    },
    setTemasWithEixo (val) {
      let eixosObrigatorios = this.eixos.filter(eixo => eixo.nacional === true || eixo.nacional === 'true')
      this.temasEixosObrigatorio = this.temas.filter(tema =>
        eixosObrigatorios.some(eixo => parseInt(eixo.eixoId) === parseInt(tema.eixoId))
      )

      // this.temasEixosNaoObrigatorios = this.temas.filter(tema =>
      //   eixosNaoObrigatorios.some(eixo => eixo.eixoId == tema.eixoId)
      // )
      if (val.nacional) {
        this.temasFiltrados = this.temasEixosObrigatorio
      } else {
        this.temasFiltrados = this.temas
      }
    }
  },
  data () {
    return {
      temas: [],
      eixos: [],
      temasEixosObrigatorio: [],
      temasEixosNaoObrigatorios: [],
      temasFiltrados: []
    }
  }
}
</script>
